export const endpoints = {
  session: '/session',
  sessionLocation: '/session/location',
  invitations: {
    create: '/invitations',
    roles: '/invitations/roles',
    preview: (token: string) => `/invitations/${encodeURIComponent(token)}`,
    accept: (token: string) => `/invitations/${encodeURIComponent(token)}/accept`,
  },
  /** Recorded against whichever subject raised them, so they belong to no single area. */
  activities: '/activities',
  appointments: '/appointments',
  sales: '/sales',
  customers: {
    list: '/customers',
    detail: (customerId: string) => `/customers/${customerId}`,
    creditGrants: (customerId: string) => `/customers/${customerId}/credit-grants`,
  },
  scheduler: {
    calendar: '/calendar',
    appointments: '/appointments',
    appointmentCheckIn: (appointmentId: string) => `/appointments/${appointmentId}/check-in`,
  },
  billing: {
    packages: '/packages',
    checkoutIntents: '/checkout-intents',
    purchases: (customerId: string) => `/customers/${customerId}/purchases`,
    refunds: (purchaseId: string) => `/purchases/${purchaseId}/refunds`,
    endPlan: (purchaseId: string) => `/purchases/${purchaseId}/end-plan`,
    cashSales: '/cash-sales',
  },
  platform: {
    ablefyProducts: '/platform/ablefy-products',
    ablefyProduct: (productId: string) => `/platform/ablefy-products/${productId}`,
    readyForSale: '/platform/ablefy-products/ready-for-sale',
  },
  notifications: {
    list: '/notifications',
  },
  settings: {
    workspace: '/settings/workspace',
  },
  workspace: {
    settings: '/workspace/settings',
    logo: '/workspace/settings/logo',
    stageLabels: '/workspace/stage-labels',
  },
  pipeline: {
    board: '/pipeline',
    leads: '/leads',
    activities: '/activities',
    appointments: '/appointments',
    sales: '/sales',
    leadStage: (leadId: string) => `/leads/${leadId}/stage`,
  },
  calls: {
    list: '/call-list',
    outcomes: '/call-outcomes',
    activities: '/activities',
    appointments: '/appointments',
  },
} as const

/** STOMP destinations. `/user/**` maps to Spring's per-session user destinations. */
export const topics = {
  notifications: '/user/queue/notifications',
} as const
